import { LI, UL } from "../../../../AbstractElements";

const CardBubbles = () => {
  return (
    <UL className="bubbles simple-list">
      <LI className="bubble" />
      <LI className="bubble" />
      <LI className="bubble" />
      <LI className="bubble" />
      <LI className="bubble" />
      <LI className="bubble" />
      <LI className="bubble" />
      <LI className="bubble" />
      <LI className="bubble" />
    </UL>
  );
};

export default CardBubbles;
